import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCopy, FiCheck } = FiIcons;

const SummaryPlagiarism = () => {
  const [selectedValue, setSelectedValue] = useState('');
  const [copied, setCopied] = useState(false);

  const data = {
    agregador: {
      definition: "Compilar información de fuentes citadas correctamente, pero sin aportar contenido original ni análisis propio (Turnitin, 2016)."
    },
    alteracionFuentes: {
      definition: "Tal como menciona Turnitin (2021), es cuando se proporciona información inexacta o parcial de las fuentes, dificultando su localización."
    },
    autoplagio: {
      definition: "Reutilizar el propio trabajo sin dar crédito, ya sea copiando frases anteriores o usando las mismas ideas con términos diferentes (Turnitin, 2016, 2021; McCuen, 2008, como se cita en Imran, 2010; Roka, 2017; Kulkarni et al., 2021)."
    },
    autoríaFalsa: {
      definition: "Imran (2010) explica que esto ocurre cuando se pone el nombre de alguien como autor en un artículo, aunque no haya participado realmente en su elaboración."
    },
    basadoEnFuentes: {
      definition: "Ocurre cuando no se citan correctamente las ideas o información de todas las fuentes utilizadas, incluyendo la atribución de citas incorrectas o incluso inventadas (Juhasz, 2024)."
    },
    busquedaReemplazo: {
      definition: "Se reformulan términos y expresiones importantes sin cambiar el mensaje central del contenido (Turnitin, como se cita en Correa & Londoño, 2018; Turnitin, 2016)."
    },
    citacionPerdida: {
      definition: "Se incluye información de una fuente en el documento sin dar el crédito (Imran, 2010)."
    },
    clonacion: {
      definition: "Involucra la transcripción de un trabajo y presentarlo como propio, copiándolo de forma exacta (Roka, 2017; Turnitin, como se cita en Correa & Londoño, 2018; Turnitin, 2016)."
    },
    colusionEstudiantil: {
      definition: "Turnitin (2021) afirma que es cuando se trabaja en equipo para crear un proyecto que debería ser hecho por una sola persona."
    },
    combinacionMashup: {
      definition: "Como indica Turnitin (2016), refleja mejor la idea de combinar elementos de diferentes fuentes sin citar adecuadamente, creando una obra que parece original pero no lo es."
    },
    completo: {
      definition: "Consiste en copiar íntegramente un trabajo ajeno sin reconocer al/a la autor/a original (Juhasz, 2024)."
    },
    compraVentaTrabajos: {
      definition: "Según lo expresado por Turnitin (2021), se refiere a pagarle a otra persona o empresa para realizar un trabajo y luego presentarlo como si fuera propio."
    },
    copiaNoAutorizada: {
      definition: "Tomar o modificar código sin permiso ni dar crédito es incorrecto. Siempre se debe mencionar de dónde se sacó el código en los proyectos (Turnitin, 2021; Imran, 2010)."
    },
    copiadoPegado: {
      definition: "Turnitin (2016, 2021), Imran (2010) y Roka (2017) coinciden en que es copiar texto de una fuente sin modificaciones, citas ni referencias."
    },
    directo: {
      definition: "A juicio de Juhasz (2024), ocurre cuando se copian partes específicas de una fuente sin citar ni entrecomillar."
    },
    dobleEnvio: {
      definition: "McCuen (2008, como se cita en Imran, 2010) indica que enviar el mismo trabajo a dos lugares simultáneamente, ya sea en una revista o un evento, resulta deshonesto."
    },
    error404: {
      definition: "Se refiere a citar fuentes falsas, enlaces rotos o inválidos, haciendo difícil verificar la información durante la detección de plagio (Turnitin, 2016; Kulkarni et al, 2021)."
    },
    fabricacionDatos: {
      definition: "Imran (2010) y Turnitin (2021) consideran inaceptable alterar datos lo que compromete la integridad investigativa."
    },
    hibrido: {
      definition: "Mezcla de fuentes correctamente citadas con fragmentos copiados que no tienen atribución, creando una combinación de contenido original y plagiado (Turnitin, 2016)."
    },
    intencional: {
      definition: "Es considerada como una práctica premeditada, es decir, que no ocurre por causalidad (Imran, 2010)."
    },
    involuntario: {
      definition: "La falta de citas, aunque sea accidental, puede resultar en serias repercusiones, especialmente al copiar material de otros (Imran, 2010; Turnitin, 2021; Roka, 2017)."
    },
    metaforico: {
      definition: "Kulkarni et al. (2021) señalan que se toma el trabajo de alguien más y es usado para explicar cosas de una manera más clara y sencilla."
    },
    modificacionTextoSoftware: {
      definition: "A la luz de lo señalado por Turnitin (2021), describe la práctica de modificar textos usando aplicaciones, herramientas digitales para evitar la detección de plagio."
    },
    modificacionManualTexto: {
      definition: "Cuando alguien cambia el texto, como añadiendo espacios en blanco, cambiando caracteres u otras estrategias, para que el software que detecta plagio no lo descubra (Turnitin, 2021)."
    },
    mosaico: {
      definition: "Corresponde a la mezcla de frases de diversas fuentes sin citar correctamente (Turnitin, 2021; Turnitin, como se cita en Correa & Londoño, 2018; Roka, 2017)."
    },
    parafraseoInapropiado: {
      definition: "En línea con lo dicho por Barnbaum (s.f., como se cita en Imran, 2010), es incorrecto cambiar palabras o copiar el estilo de otra oración."
    },
    parafrasisSinAtribucion: {
      definition: "Turnitin (2021) explica que es la reformulación de ideas de otra fuente sin dar el crédito correcto."
    },
    referenciaFalsa: {
      definition: "Basándose en las ideas de Imran (2010), es una fuente inexistente o incorrecta, la cual no respalda la información presentada."
    },
    retuiteo: {
      definition: "Se comparte contenido casi idéntico al original, sin aportar cambios significativos (Kulkarni et al., 2021; Turnitin, 2016)."
    },
    remezcladoRemix: {
      definition: "Involucra la fusión de información reescrita de varias fuentes y combinarlas en una nueva forma (Turnitin, 2016)."
    },
    roboIdeas: {
      definition: "Siguiendo lo establecido por Imran (2010) y Roka (2017), tomar ideas ajenas y presentarlas como propias es considerado fraudulento."
    },
    roboMaterial: {
      definition: "Imran (2010) explicó acerca de copiar el trabajo de alguien sin pedir autorización."
    },
    usoInapropiadoIA: {
      definition: "Como señala Juhasz (2024), abarca el uso de herramientas de inteligencia artificial (IA) para crear contenido sin reconocer las fuentes adecuadamente."
    }
  };

  const handleSelectChange = (e) => {
    setSelectedValue(e.target.value);
    setCopied(false);
  };

  const copyToClipboard = () => {
    if (selectedValue && data[selectedValue]) {
      navigator.clipboard.writeText(data[selectedValue].definition);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="max-w-4xl mx-auto px-4 py-12"
    >
      <div className="text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-red-500 to-orange-500 bg-clip-text text-transparent mb-6">
          Resumen - Tipos de Plagio
        </h1>
        <p className="text-xl text-gray-600 dark:text-gray-300">
          Consulta las definiciones de los diferentes tipos de plagio
        </p>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-6 md:p-8">
        <div className="space-y-6">
          <select 
            value={selectedValue}
            onChange={handleSelectChange}
            className="w-full p-4 text-lg border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
          >
            <option value="">-- Selecciona un tipo de plagio --</option>
            <optgroup label="Tipos de Plagio">
              <option value="agregador">Agregador</option>
              <option value="alteracionFuentes">Alteración de fuentes</option>
              <option value="autoplagio">Autoplagio / contenido reciclado</option>
              <option value="autoríaFalsa">Autoría falsa</option>
              <option value="basadoEnFuentes">Basado en fuentes</option>
              <option value="busquedaReemplazo">Búsqueda y reemplazo</option>
              <option value="citacionPerdida">Citación perdida</option>
              <option value="clonacion">Clonación</option>
              <option value="colusionEstudiantil">Colusión estudiantil</option>
              <option value="combinacionMashup">Combinación (mashup)</option>
              <option value="completo">Completo</option>
              <option value="compraVentaTrabajos">Compra-venta de trabajos</option>
              <option value="copiaNoAutorizada">Copia no autorizada del código fuente o código de programación</option>
              <option value="copiadoPegado">Copiado y pegado (Ctrl+C y Ctrl+V)</option>
              <option value="directo">Directo</option>
              <option value="dobleEnvio">Doble envío</option>
              <option value="error404">Error 404 / Fuente ilegítima</option>
              <option value="fabricacionDatos">Fabricación de datos</option>
              <option value="hibrido">Híbrido</option>
              <option value="intencional">Intencional</option>
              <option value="involuntario">Involuntario</option>
              <option value="metaforico">Metafórico</option>
              <option value="modificacionTextoSoftware">Modificación de texto con software</option>
              <option value="modificacionManualTexto">Modificación manual del texto</option>
              <option value="mosaico">Mosaico</option>
              <option value="parafraseoInapropiado">Parafraseo inapropiado</option>
              <option value="parafrasisSinAtribucion">Paráfrasis sin atribución</option>
              <option value="referenciaFalsa">Referencia falsa</option>
              <option value="retuiteo">Retuiteo</option>
              <option value="remezcladoRemix">Remezclado (remix)</option>
              <option value="roboIdeas">Robo de ideas</option>
              <option value="roboMaterial">Robo de material</option>
              <option value="usoInapropiadoIA">Uso inapropiado por inteligencia artificial (IA)</option>
            </optgroup>
          </select>

          {selectedValue && data[selectedValue] && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="mt-6 p-6 bg-gray-50 dark:bg-gray-700 rounded-lg"
            >
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Definición:
                </h3>
                <motion.button
                  onClick={copyToClipboard}
                  className="flex items-center space-x-2 px-3 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg transition-colors duration-200"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <SafeIcon icon={copied ? FiCheck : FiCopy} className="w-4 h-4" />
                  <span className="text-sm">{copied ? 'Copiado' : 'Copiar'}</span>
                </motion.button>
              </div>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed text-justify">
                {data[selectedValue].definition}
              </p>
            </motion.div>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default SummaryPlagiarism;